module.exports = __webpack_public_path__ + "img/image.477daa0e.svg";